export const en = {
  menu: {
    admin: {
      root: 'Admin',
      organizations: 'Organizations',
      users: 'Users',
      aiManagement: 'AI Management',
      agents: 'Agents',
      aiAgents: 'Agents',
      aiUsage: 'Usage',
    },
  },
  aiManagement: {
    loading: {
      agent: 'Loading agent...',
      usageData: 'Loading usage data...',
    },
    errors: {
      agentNotFound: 'Failed to load agent',
      organizationNotFound: 'Organization not found',
    },
    tools: {
      names: {
        'crm-account-list': 'List Accounts',
        'crm-account-get': 'Get Account',
        'crm-account-create': 'Create Account',
        'crm-contact-list': 'List Contacts',
        'crm-account-delete': 'Delete Account',
        'crm-account-update': 'Update Account',
        'crm-accountAddress-create': 'Create Account Address',
        'crm-accountAddress-delete': 'Delete Account Address',
        'crm-accountAddress-get': 'Get Account Address',
        'crm-accountAddress-list': 'List Account Addresses',
        'crm-accountAddress-update': 'Update Account Address',
        'crm-contact-create': 'Create Contact',
        'crm-contact-delete': 'Delete Contact',
        'crm-contact-get': 'Get Contact',
        'crm-contact-update': 'Update Contact',
        'crm-customerInvitation-accept': 'Accept Customer Invitation',
        'crm-customerInvitation-cancel': 'Cancel Customer Invitation',
        'crm-customerInvitation-create': 'Create Customer Invitation',
        'crm-customerInvitation-get': 'Get Customer Invitation',
        'crm-customerInvitation-getByToken': 'Get Customer Invitation by Token',
        'crm-customerInvitation-list': 'List Customer Invitations',

        'sales-salesOrder-list': 'List Sales Orders',
        'sales-salesOrder-get': 'Get Sales Order',
        'sales-booking-create': 'Create Booking',
        'sales-booking-get': 'Get Booking',
        'sales-booking-list': 'List Bookings',
        'sales-booking-update': 'Update Booking',
        'sales-deductionType-create': 'Create Deduction Type',
        'sales-deductionType-delete': 'Delete Deduction Type',
        'sales-deductionType-get': 'Get Deduction Type',
        'sales-deductionType-list': 'List Deduction Types',
        'sales-deductionType-update': 'Update Deduction Type',
        'sales-load-create': 'Create Load',
        'sales-load-get': 'Get Load',
        'sales-load-list': 'List Loads',
        'sales-load-update': 'Update Load',
        'sales-loadReconciliation-delete': 'Delete Load Reconciliation',
        'sales-loadReconciliation-update': 'Update Load Reconciliation',
        'sales-salesOrder-create': 'Create Sales Order',
        'sales-salesOrder-update': 'Update Sales Order',
        'inventory-item-list': 'List Inventory Items',
        'inventory-item-get': 'Get Inventory Item',
        'inventory-category-create': 'Create Category',
        'inventory-category-delete': 'Delete Category',
        'inventory-category-get': 'Get Category',
        'inventory-category-list': 'List Categories',
        'inventory-category-update': 'Update Category',
        'inventory-inventoryTag-create': 'Create Inventory Tag',
        'inventory-inventoryTag-delete': 'Delete Inventory Tag',
        'inventory-inventoryTag-get': 'Get Inventory Tag',
        'inventory-inventoryTag-list': 'List Inventory Tags',
        'inventory-inventoryTag-update': 'Update Inventory Tag',
        'inventory-item-create': 'Create Item',
        'inventory-item-delete': 'Delete Item',
        'inventory-item-update': 'Update Item',
        'inventory-itemGroup-create': 'Create Item Group',
        'inventory-itemGroup-delete': 'Delete Item Group',
        'inventory-itemGroup-get': 'Get Item Group',
        'inventory-itemGroup-list': 'List Item Groups',
        'inventory-itemGroup-update': 'Update Item Group',
        'core-customAttribute-create': 'Create Custom Attribute',
        'core-customAttribute-delete': 'Delete Custom Attribute',
        'core-customAttribute-get': 'Get Custom Attribute',
        'core-customAttribute-list': 'List Custom Attributes',
        'core-customAttribute-update': 'Update Custom Attribute',
        'core-customAttribute-validate': 'Validate Custom Attribute',
        'core-facility-create': 'Create Facility',
        'core-facility-get': 'Get Facility',
        'core-facility-list': 'List Facilities',
        'core-facilityGroup-assignFacility':
          'Assign Facility to Facility Group',
        'core-facilityGroup-create': 'Create Facility Group',
        'core-facilityGroup-get': 'Get Facility Group',
        'core-facilityGroup-list': 'List Facility Groups',
        'core-facilityGroup-removeFacility':
          'Remove Facility from Facility Group',
        'core-facilityGroup-update': 'Update Facility Group',
        'core-organization-create': 'Create Organization',
        'core-organization-delete': 'Delete Organization',
        'core-organization-get': 'Get Organization',
        'core-organization-list': 'List Organizations',
        'core-organization-update': 'Update Organization',
        'core-scopedSettingValues-getBySetting': 'Get Scoped Setting Values',
        'core-scopedSettingValues-patch': 'Patch Scoped Setting Values',
        'core-setting-create': 'Create Setting',
        'core-setting-delete': 'Delete Setting',
        'core-setting-get': 'Get Setting',
        'core-setting-list': 'List Settings',
        'core-setting-update': 'Update Setting',
        'core-settingsGroup-create': 'Create Settings Group',
        'core-settingsGroup-delete': 'Delete Settings Group',
        'core-settingsGroup-get': 'Get Settings Group',
        'core-settingsGroup-list': 'List Settings Groups',
        'core-settingsGroup-update': 'Update Settings Group',
        'core-user-create': 'Create User',
        'core-user-get': 'Get User',
        'core-user-list': 'List Users',
        'files-file-generateAccessURL': 'Generate File Access URL',
        'files-file-get': 'Get File',
        'files-file-list': 'List Files',
        'files-fileTemplate-get': 'Get File Template',
        'files-fileTemplate-list': 'List File Templates',
        'files-fileTemplate-set': 'Set File Template',
        'files-fileTemplate-remove': 'Remove File Template',
        'finance-bill-create': 'Create Bill',
        'finance-bill-get': 'Get Bill',
        'finance-bill-list': 'List Bills',
        'finance-financialAccount-create': 'Create Financial Account',
        'finance-financialAccount-list': 'List Financial Accounts',
        'finance-invoice-create': 'Create Invoice',
        'finance-invoice-get': 'Get Invoice',
        'finance-invoice-list': 'List Invoices',
        'finance-payment-create': 'Create Payment',
        'finance-payment-list': 'List Payments',
        'general-chart-create': 'Create Chart',
        'general-dateTime': 'Get Date/Time',
        'general-python-execute': 'Execute Python Code',
        'general-userInput': 'Request User Input',
        'purchases-purchaseOrder-list': 'List Purchase Orders',
        'purchases-purchaseOrder-get': 'Get Purchase Order',
        'purchases-purchaseOrder-create': 'Create Purchase Order',
        'purchases-purchaseOrder-update': 'Update Purchase Order',
        'transportation-asset-create': 'Create Asset',
        'transportation-asset-delete': 'Delete Asset',
        'transportation-asset-get': 'Get Asset',
        'transportation-asset-list': 'List Assets',
        'transportation-asset-update': 'Update Asset',
        'transportation-assetType-create': 'Create Asset Type',
        'transportation-assetType-delete': 'Delete Asset Type',
        'transportation-assetType-get': 'Get Asset Type',
        'transportation-assetType-list': 'List Asset Types',
        'transportation-assetType-update': 'Update Asset Type',
        'transportation-containerType-create': 'Create Container Type',
        'transportation-containerType-delete': 'Delete Container Type',
        'transportation-containerType-get': 'Get Container Type',
        'transportation-containerType-list': 'List Container Types',
        'transportation-containerType-update': 'Update Container Type',
        'transportation-driver-create': 'Create Driver',
        'transportation-driver-get': 'Get Driver',
        'transportation-driver-list': 'List Drivers',
        'transportation-driver-update': 'Update Driver',
        'transportation-freightForwarder-create': 'Create Freight Forwarder',
        'transportation-freightForwarder-delete': 'Delete Freight Forwarder',
        'transportation-freightForwarder-get': 'Get Freight Forwarder',
        'transportation-freightForwarder-list': 'List Freight Forwarders',
        'transportation-freightForwarder-update': 'Update Freight Forwarder',
        'transportation-freightLine-create': 'Create Freight Line',
        'transportation-freightLine-delete': 'Delete Freight Line',
        'transportation-freightLine-get': 'Get Freight Line',
        'transportation-freightLine-list': 'List Freight Lines',
        'transportation-freightLine-update': 'Update Freight Line',
        'transportation-hauler-add': 'Add Hauler',
        'transportation-hauler-remove': 'Remove Hauler',
        'transportation-route-create': 'Create Route',
        'transportation-route-get': 'Get Route',
        'transportation-route-list': 'List Routes',
        'transportation-route-update': 'Update Route',
        'transportation-shippingCarrier-create': 'Create Shipping Carrier',
        'transportation-shippingCarrier-delete': 'Delete Shipping Carrier',
        'transportation-shippingCarrier-get': 'Get Shipping Carrier',
        'transportation-shippingCarrier-list': 'List Shipping Carriers',
        'transportation-shippingCarrier-update': 'Update Shipping Carrier',
        'transportation-task-create': 'Create Task',
        'transportation-task-get': 'Get Task',
        'transportation-task-list': 'List Tasks',
        'transportation-task-update': 'Update Task',
        'transportation-trailer-create': 'Create Trailer',
        'transportation-trailer-get': 'Get Trailer',
        'transportation-trailer-list': 'List Trailers',
        'transportation-trailer-update': 'Update Trailer',
        'transportation-transportationType-create':
          'Create Transportation Type',
        'transportation-transportationType-delete':
          'Delete Transportation Type',
        'transportation-transportationType-get': 'Get Transportation Type',
        'transportation-transportationType-list': 'List Transportation Types',
        'transportation-transportationType-update':
          'Update Transportation Type',
        'transportation-truck-create': 'Create Truck',
        'transportation-truck-get': 'Get Truck',
        'transportation-truck-list': 'List Trucks',
        'transportation-truck-update': 'Update Truck',
      },
      descriptions: {
        'crm-account-list':
          'Searches for CRM accounts based on a set of filters',
        'crm-account-get': 'Gets a specific account by its ID',
        'crm-account-create': 'Creates a CRM account',
        'crm-account-delete': 'Deletes a CRM account',
        'crm-account-update': 'Updates a CRM account',
        'crm-accountAddress-create': 'Creates an account address',
        'crm-accountAddress-delete': 'Deletes an account address',
        'crm-accountAddress-get': 'Gets a specific account address by its ID',
        'crm-accountAddress-list':
          'Searches for account addresses based on a set of filters',
        'crm-accountAddress-update': 'Updates an account address',
        'crm-contact-list': 'Searches for account contacts in the CRM module',
        'crm-contact-create': 'Creates a contact',
        'crm-contact-delete': 'Deletes a contact',
        'crm-contact-get': 'Gets a specific contact by its ID',
        'crm-contact-update': 'Updates a contact',
        'crm-customerInvitation-accept': 'Accepts a customer invitation',
        'crm-customerInvitation-cancel': 'Cancels a customer invitation',
        'crm-customerInvitation-create': 'Creates a customer invitation',
        'crm-customerInvitation-get': 'Gets a customer invitation by its ID',
        'crm-customerInvitation-getByToken':
          'Gets a customer invitation by its token',
        'crm-customerInvitation-list':
          'Searches for customer invitations based on a set of filters',

        'sales-salesOrder-list':
          'Searches for sales orders based on a set of filters',
        'sales-salesOrder-get': 'Gets a specific sales order by its ID',
        'sales-salesOrder-create': 'Creates a sales order',
        'sales-salesOrder-update': 'Updates a sales order',
        'sales-booking-create': 'Creates a booking',
        'sales-booking-get': 'Gets a specific booking by its ID',
        'sales-booking-list': 'Searches for bookings based on a set of filters',
        'sales-booking-update': 'Updates a booking',
        'sales-deductionType-create': 'Creates a deduction type',
        'sales-deductionType-delete': 'Deletes a deduction type',
        'sales-deductionType-get': 'Gets a specific deduction type by its ID',
        'sales-deductionType-list':
          'Searches for deduction types based on a set of filters',
        'sales-deductionType-update': 'Updates a deduction type',
        'sales-load-create': 'Creates a load',
        'sales-load-get': 'Gets a specific load by its ID',
        'sales-load-list': 'Searches for loads based on a set of filters',
        'sales-load-update': 'Updates a load',
        'sales-loadReconciliation-delete': 'Deletes a load reconciliation',
        'sales-loadReconciliation-update': 'Updates a load reconciliation',

        'inventory-item-list':
          'Lists and searches for inventory items (materials) in the Inventory Library',
        'inventory-item-get': 'Gets and inventory item by its ID',
        'inventory-item-create': 'Creates an inventory item',
        'inventory-item-delete': 'Deletes an inventory item',
        'inventory-item-update': 'Updates an inventory item',
        'inventory-category-create': 'Creates an inventory category',
        'inventory-category-delete': 'Deletes an inventory category',
        'inventory-category-get':
          'Gets a specific inventory category by its ID',
        'inventory-category-list':
          'Searches for inventory categories based on a set of filters',
        'inventory-category-update': 'Updates an inventory category',
        'inventory-inventoryTag-create': 'Creates an inventory tag',
        'inventory-inventoryTag-delete': 'Deletes an inventory tag',
        'inventory-inventoryTag-get': 'Gets a specific inventory tag by its ID',
        'inventory-inventoryTag-list':
          'Searches for inventory tags based on a set of filters',
        'inventory-inventoryTag-update': 'Updates an inventory tag',
        'inventory-itemGroup-create': 'Creates an inventory item group',
        'inventory-itemGroup-delete': 'Deletes an inventory item group',
        'inventory-itemGroup-get':
          'Gets a specific inventory item group by its ID',
        'inventory-itemGroup-list':
          'Searches for inventory item groups based on a set of filters',
        'inventory-itemGroup-update': 'Updates an inventory item group',

        'core-customAttribute-create': 'Creates a custom attribute',
        'core-customAttribute-delete': 'Deletes a custom attribute',
        'core-customAttribute-get':
          'Gets a specific custom attribute by its ID',
        'core-customAttribute-list':
          'Searches for custom attributes based on a set of filters',
        'core-customAttribute-update': 'Updates a custom attribute',
        'core-customAttribute-validate': 'Validates a custom attribute',
        'core-facility-create': 'Creates a facility',
        'core-facility-get': 'Gets a specific facility by its ID',
        'core-facility-list':
          'Searches for facilities based on a set of filters',
        'core-facilityGroup-assignFacility':
          'Assigns a facility to a facility group',
        'core-facilityGroup-create': 'Creates a facility group',
        'core-facilityGroup-get': 'Gets a specific facility group by its ID',
        'core-facilityGroup-list':
          'Searches for facility groups based on a set of filters',
        'core-facilityGroup-removeFacility':
          'Removes a facility from a facility group',
        'core-facilityGroup-update': 'Updates a facility group',
        'core-organization-create': 'Creates an organization',
        'core-organization-delete': 'Deletes an organization',
        'core-organization-get': 'Gets a specific organization by its ID',
        'core-organization-list':
          'Searches for organizations based on a set of filters',
        'core-organization-update': 'Updates an organization',
        'core-scopedSettingValues-getBySetting':
          'Gets scoped setting values for a setting',
        'core-scopedSettingValues-patch': 'Patches scoped setting values',
        'core-setting-create': 'Creates a setting',
        'core-setting-delete': 'Deletes a setting',
        'core-setting-get': 'Gets a specific setting by its ID',
        'core-setting-list': 'Searches for settings based on a set of filters',
        'core-setting-update': 'Updates a setting',
        'core-settingsGroup-create': 'Creates a settings group',
        'core-settingsGroup-delete': 'Deletes a settings group',
        'core-settingsGroup-get': 'Gets a specific settings group by its ID',
        'core-settingsGroup-list':
          'Searches for settings groups based on a set of filters',
        'core-settingsGroup-update': 'Updates a settings group',
        'core-user-create': 'Creates a user',
        'core-user-get': 'Gets a specific user by its ID',
        'core-user-list': 'Searches for users based on a set of filters',

        'files-file-generateAccessURL': 'Generates an access URL for a file',
        'files-file-get': 'Gets a specific file by its ID',
        'files-file-list': 'Searches for files based on a set of filters',
        'files-fileTemplate-get': 'Gets a file template',
        'files-fileTemplate-list':
          'Searches for file templates based on a set of filters',
        'files-fileTemplate-set': 'Sets a file template',
        'files-fileTemplate-remove': 'Removes a file template',

        'finance-bill-create': 'Creates a bill',
        'finance-bill-get': 'Gets a specific bill by its ID',
        'finance-bill-list': 'Searches for bills based on a set of filters',
        'finance-financialAccount-create': 'Creates a financial account',
        'finance-financialAccount-list':
          'Searches for financial accounts based on a set of filters',
        'finance-invoice-create': 'Creates an invoice',
        'finance-invoice-get': 'Gets a specific invoice by its ID',
        'finance-invoice-list':
          'Searches for invoices based on a set of filters',
        'finance-payment-create': 'Creates a payment',
        'finance-payment-list':
          'Searches for payments based on a set of filters',

        'general-chart-create':
          'Create interactive data visualizations (line, area, bar, pie, scatter, bubble charts) from JSON data',
        'general-dateTime': 'Returns the current date and time',
        'general-python-execute':
          'Execute Python code with pre-loaded libraries: numpy, pandas, matplotlib, scipy, statsmodels',
        'general-userInput': 'Requests input from the user',

        'purchases-purchaseOrder-list':
          'Searches for purchase orders based on a set of filters',
        'purchases-purchaseOrder-get':
          'Gets a specific purchase order by its ID',
        'purchases-purchaseOrder-create': 'Creates a purchase order',
        'purchases-purchaseOrder-update': 'Updates a purchase order',

        'transportation-asset-create': 'Creates a transportation asset',
        'transportation-asset-delete': 'Deletes a transportation asset',
        'transportation-asset-get':
          'Gets a specific transportation asset by its ID',
        'transportation-asset-list':
          'Searches for transportation assets based on a set of filters',
        'transportation-asset-update': 'Updates a transportation asset',
        'transportation-assetType-create':
          'Creates a transportation asset type',
        'transportation-assetType-delete':
          'Deletes a transportation asset type',
        'transportation-assetType-get':
          'Gets a specific transportation asset type by its ID',
        'transportation-assetType-list':
          'Searches for transportation asset types based on a set of filters',
        'transportation-assetType-update':
          'Updates a transportation asset type',
        'transportation-containerType-create': 'Creates a container type',
        'transportation-containerType-delete': 'Deletes a container type',
        'transportation-containerType-get':
          'Gets a specific container type by its ID',
        'transportation-containerType-list':
          'Searches for container types based on a set of filters',
        'transportation-containerType-update': 'Updates a container type',
        'transportation-driver-create': 'Creates a driver',
        'transportation-driver-get': 'Gets a specific driver by its ID',
        'transportation-driver-list':
          'Searches for drivers based on a set of filters',
        'transportation-driver-update': 'Updates a driver',
        'transportation-freightForwarder-create': 'Creates a freight forwarder',
        'transportation-freightForwarder-delete': 'Deletes a freight forwarder',
        'transportation-freightForwarder-get':
          'Gets a specific freight forwarder by its ID',
        'transportation-freightForwarder-list':
          'Searches for freight forwarders based on a set of filters',
        'transportation-freightForwarder-update': 'Updates a freight forwarder',
        'transportation-freightLine-create': 'Creates a freight line',
        'transportation-freightLine-delete': 'Deletes a freight line',
        'transportation-freightLine-get':
          'Gets a specific freight line by its ID',
        'transportation-freightLine-list':
          'Searches for freight lines based on a set of filters',
        'transportation-freightLine-update': 'Updates a freight line',
        'transportation-hauler-add': 'Adds a hauler',
        'transportation-hauler-remove': 'Removes a hauler',
        'transportation-route-create': 'Creates a route',
        'transportation-route-get': 'Gets a specific route by its ID',
        'transportation-route-list':
          'Searches for routes based on a set of filters',
        'transportation-route-update': 'Updates a route',
        'transportation-shippingCarrier-create': 'Creates a shipping carrier',
        'transportation-shippingCarrier-delete': 'Deletes a shipping carrier',
        'transportation-shippingCarrier-get':
          'Gets a specific shipping carrier by its ID',
        'transportation-shippingCarrier-list':
          'Searches for shipping carriers based on a set of filters',
        'transportation-shippingCarrier-update': 'Updates a shipping carrier',
        'transportation-task-create': 'Creates a transportation task',
        'transportation-task-get':
          'Gets a specific transportation task by its ID',
        'transportation-task-list':
          'Searches for transportation tasks based on a set of filters',
        'transportation-task-update': 'Updates a transportation task',
        'transportation-trailer-create': 'Creates a trailer',
        'transportation-trailer-get': 'Gets a specific trailer by its ID',
        'transportation-trailer-list':
          'Searches for trailers based on a set of filters',
        'transportation-trailer-update': 'Updates a trailer',
        'transportation-transportationType-create':
          'Creates a transportation type',
        'transportation-transportationType-delete':
          'Deletes a transportation type',
        'transportation-transportationType-get':
          'Gets a specific transportation type by its ID',
        'transportation-transportationType-list':
          'Searches for transportation types based on a set of filters',
        'transportation-transportationType-update':
          'Updates a transportation type',
        'transportation-truck-create': 'Creates a truck',
        'transportation-truck-get': 'Gets a specific truck by its ID',
        'transportation-truck-list':
          'Searches for trucks based on a set of filters',
        'transportation-truck-update': 'Updates a truck',
      },
      categories: {
        crm: 'CRM',
        sales: 'Sales',
        inventory: 'Inventory',
        core: 'Core',
        files: 'Files',
        finance: 'Finance',
        general: 'General',
        purchases: 'Purchases',
        transportation: 'Transportation',
        other: 'Other',
      },
    },
    agents: {
      tabs: {
        all: 'All Agent Types',
        agent: 'Agents',
        subAgents: 'Sub Agents',
        prompt: 'Prompt',
        tools: 'Tools',
      },
      toolCount: {
        singular: 'tool',
        plural: 'tools',
      },
      header: {
        name: 'Name',
        type: 'Type',
        agentId: 'Agent ID',
        status: 'Status',
        provider: 'Provider',
        model: 'Model',
        tools: 'Tools',
        version: 'Version',
        createdAt: 'Created Date',
        actions: 'Actions',
      },
      type: {
        agent: 'Agent',
        subAgent: 'Sub Agent',
        fileProcessor: 'File Processor',
      },
      status: {
        active: 'Active',
        inactive: 'Inactive',
      },
      details: {
        tabs: {
          configuration: 'Details',
        },
        sections: {
          basicInfo: 'Basic Information',
          tools: 'Available Tools',
          modelConfig: 'AI Model Configuration',
        },
        fields: {
          name: {
            label: 'Name',
            placeholder: 'Enter agent name',
          },
          type: {
            label: 'Type',
            agent: {
              label: 'Agent',
              description: 'A main agent applies to all conversations',
            },
            subAgent: {
              label: 'Sub Agent',
              description: 'A sub agent is specific to a particular task',
            },
            fileProcessor: {
              label: 'File Processor',
              description:
                'Preprocesses files and documents using a vision model',
            },
          },
          agentIdentifier: {
            label: 'Agent Identifier',
            placeholder: 'agent-name',
            validation: {
              pattern: 'Only lowercase letters, numbers, and hyphens allowed',
            },
          },
          content: {
            label: 'Content',
            placeholder: 'Enter the agent content...',
            description: 'The content that will be used by the AI agent',
          },
          tools: {
            description: 'Select the tools available to this agent',
            placeholder: 'Search and select tools',
          },
          isActive: {
            label: 'Active',
            description: 'When active, this agent can be used in conversations',
          },
          provider: {
            label: 'Provider',
            options: {
              gemini: 'Google Gemini',
              openai: 'OpenAI',
              anthropic: 'Anthropic',
              cerebras: 'Cerebras',
            },
          },
          model: {
            label: 'Model',
            placeholder:
              'e.g., gemini-2.5-flash, gpt-4o, claude-sonnet-4-5, llama3.1-8b',
          },
          apiKey: {
            label: 'Provider API Key',
            placeholder: 'Enter API key (leave blank to keep existing)',
          },
          baseUrl: {
            label: 'Provider Base URL (Optional)',
            placeholder: 'https://...',
          },
          temperature: {
            label: 'Temperature',
          },
          reasoning: {
            label: 'Reasoning',
          },
          reasoningBudget: {
            label: 'Reasoning Budget',
          },
        },
      },
      actions: {
        create: 'Create Agent',
        createAgent: 'Create Agent',
        createSubAgent: 'Create Sub Agent',
        createFileProcessor: 'Create File Processor',
        edit: 'Edit',
        activate: 'Activate',
        deactivate: 'Deactivate',
        clearFilters: 'Clear Filters',
        cancel: 'Cancel',
        save: 'Save',
      },
      empty: {
        title: 'No agents found',
        description: 'Create an agent to get started',
      },
      notifications: {
        activated: 'Agent activated successfully',
        deactivated: 'Agent deactivated successfully',
        error: 'Failed to save agent. Please try again.',
      },
      searchPlaceholder: 'Search agents by name...',
      filterByType: 'Filter by type',
      filterByStatus: 'Filter by status',
      filterStatusAll: 'Active & Inactive',
      filterStatusActive: 'Active',
      filterStatusInactive: 'Inactive',
    },
    usage: {
      header: {
        organization: 'Organization',
        modelProvider: 'Provider',
        model: 'Model',
        totalTokens: 'Total Tokens',
        totalCost: 'Total Cost',
        recordCount: 'Records',
        period: 'Period',
        actions: 'Actions',
      },
      filters: {
        dateRange: 'Period',
        modelProvider: 'Provider',
        model: 'Model',
        clearFilters: 'Clear Filters',
        allProviders: 'All Providers',
      },
      actions: {
        viewDetails: 'View Details',
      },
      empty: {
        title: 'No usage data',
        description: 'No AI usage metrics found for the selected filters',
      },
      organizationDetail: {
        title: (orgName: string) => `Usage for ${orgName}`,
        summary: {
          totalTokens: 'Total Tokens',
          totalCost: 'Total Cost',
          mostUsedModel: 'Most Used Model',
          dateRange: 'Date Range',
        },
        tabs: {
          details: 'Detailed Records',
        },
      },
    },
  },
  organizationDetailView: {
    tabs: {
      details: 'Details',
      entitlements: 'Entitlements',
    },
    sections: {
      basicInfo: 'Basic Information',
      facilities: 'Facilities',
      noFacilities: 'No facilities',
      users: 'Users',
      noUsers: 'No users',
    },
    fields: {
      name: 'Name',
      domain: 'Domain',
      timezone: 'Timezone',
      idpId: 'Identity Provider ID',
      createdAt: 'Created Date',
      updatedAt: 'Updated Date',
    },
  },
  organizationListView: {
    searchPlaceholder: 'Search organizations by name or domain...',
    header: {
      name: 'Name',
      domain: 'Domain',
      createdAt: 'Created Date',
      updatedAt: 'Updated Date',
      userCount: 'Users',
      status: 'Status',
      actions: 'Actions',
    },
    status: {
      onboarded: 'Onboarded',
      pending: 'Pending',
    },
    actions: {
      provision: 'Provision',
      viewDetails: 'View Details',
      edit: 'Edit',
      setAsOnboarded: 'Mark as Onboarded',
      reset: 'Reset',
    },
    empty: {
      title: 'No organizations found',
      description: 'Try adjusting your search or filters.',
    },
  },
  organizationDetailsDialog: {
    title: {
      create: 'New Organization',
      edit: 'Edit Organization',
    },
    fields: {
      name: {
        label: 'Organization Name',
        placeholder: 'Enter organization name',
      },
      domain: {
        label: 'Domain',
        placeholder: 'example.com',
        description: 'The email domain for this organization',
      },
      timezone: {
        label: 'Timezone',
        placeholder: 'Select a timezone',
      },
      idpId: {
        label: 'Identity Provider ID',
        placeholder: 'Enter IDP ID (optional)',
        description: 'External identity provider reference',
      },
    },
    actions: {
      cancel: 'Cancel',
      create: 'Create Organization',
      save: 'Save Changes',
    },
    saveSuccess: {
      create: 'Organization created successfully',
      update: 'Organization updated successfully',
    },
    saveError: 'Failed to save organization. Please try again.',
  },
  userListView: {
    searchPlaceholder: 'Search users by name or email...',
    filterByOrganization: 'Select organization',
    filterByStatus: 'Filter by status',
    header: {
      name: 'Name',
      email: 'Email',
      organization: 'Organizations',
      phoneNumber: 'Phone',
      timezone: 'Timezone',
      status: 'Status',
      createdAt: 'Created Date',
      actions: 'Actions',
    },
    status: {
      all: 'All Statuses',
      active: 'Active',
      archived: 'Archived',
    },
    actions: {
      create: 'Add User',
      edit: 'Edit',
      manageOrganizations: 'Manage Organizations',
      manageAdminAccess: 'Manage Admin Access',
      removeFromOrganization: 'Remove from Organization',
      addToOrganization: 'Add to Organization',
    },
    empty: {
      title: 'No users found',
      description: 'Try adjusting your search or filters.',
      selectOrganization: 'Select an organization',
      selectOrganizationDescription:
        'Please select an organization to view its users.',
    },
  },
  userDetailsDialog: {
    title: {
      create: 'New User',
      edit: 'Edit User',
    },
    fields: {
      firstName: {
        label: 'First Name',
        placeholder: 'Enter first name',
      },
      lastName: {
        label: 'Last Name',
        placeholder: 'Enter last name',
      },
      email: {
        label: 'Email',
        placeholder: 'user@example.com',
      },
      phoneNumber: {
        label: 'Phone Number',
        placeholder: 'Enter phone number (optional)',
      },
      organization: {
        label: 'Organization',
        placeholder: 'Search and select organization',
        description: 'The user will be added to this organization',
      },
      timezone: {
        label: 'Timezone',
        placeholder: 'Select a timezone',
      },
      idpId: {
        label: 'Identity Provider ID',
        placeholder: 'Enter IDP ID (optional)',
        description: 'External identity provider reference',
      },
    },
    actions: {
      cancel: 'Cancel',
      create: 'Create User',
      save: 'Save Changes',
    },
    saveSuccess: {
      create: 'User created successfully',
      update: 'User updated successfully',
    },
    saveError: 'Failed to save user. Please try again.',
  },
  addUserToOrganizationDialog: {
    title: 'Add User to Organization',
    userInfo: 'Adding user:',
    currentOrganizations: 'Current organizations:',
    noOrganizationsAvailable:
      'No available organizations. This user is already a member of all organizations.',
    fields: {
      organization: {
        label: 'Organization',
        placeholder: 'Search and select organization',
      },
    },
    actions: {
      cancel: 'Cancel',
      add: 'Add to Organization',
    },
    saveSuccess: 'User successfully added to organization',
    saveError: 'Failed to add user to organization. Please try again.',
  },
  manageUserOrganizationsDialog: {
    title: 'Manage User Organizations',
    userInfo: 'Managing organizations for:',
    currentOrganizations: 'Organizations',
    addOrganization: 'Add Organization',
    noOrganizationsAvailable:
      'No organizations available to add. This user is already a member of all organizations.',
    fields: {
      organization: {
        label: 'Organization',
        placeholder: 'Search and select organization to add',
      },
    },
    pendingChanges: {
      adding: '{count} organization(s) will be added',
      removing: '{count} organization(s) will be removed',
    },
    actions: {
      cancel: 'Cancel',
      save: 'Save Changes',
    },
    badges: {
      willRemove: 'Queued for removal - Click to undo',
      willAdd: 'Will be added - Click to cancel',
      clickToRemove: 'Click to remove from user',
    },
    saveSuccess: 'Organization changes saved successfully',
    saveError: 'Failed to save organization changes. Please try again.',
  },
  manageAdminAccessDialog: {
    title: 'Manage Admin Access',
    userInfo: 'Managing admin access for:',
    selectOrganization: 'Select Organization',
    instructions:
      'Grant or revoke admin access for this user in the selected organization.',
    fields: {
      organization: {
        placeholder: 'Search and select organization',
      },
    },
    actions: {
      cancel: 'Cancel',
      grant: 'Grant Admin Access',
      revoke: 'Revoke Admin Access',
    },
    grantSuccess: 'Admin access granted successfully',
    grantError: 'Failed to grant admin access. Please try again.',
    revokeSuccess: 'Admin access revoked successfully',
    revokeError: 'Failed to revoke admin access. Please try again.',
  },

  resetOrganizationDialog: {
    title: 'Reset Organization',
    warningTitle: 'Warning:',
    warningDescription: (name: string) =>
      `This action cannot be undone. All existing data in "${name}" will become inaccessible.`,
    consequencesTitle: 'The following actions will be performed:',
    consequences: [
      "Current organization will be renamed with '[Deleted]'",
      'New organization will be created with the original name',
      'A default facility will be created',
      'Users will be reassigned to the new organization',
      'Default templates will be uploaded',
    ],
    confirmLabel: 'Type RESET to confirm',
    actions: {
      cancel: 'Cancel',
      reset: 'Reset Organization',
      resetting: 'Resetting...',
    },
    success: 'Organization has been successfully reset.',
    error: 'Failed to reset organization. Please try again.',
  },
  entitlements: {
    sidebar: {
      title: 'Entitlements',
      reports: 'Reports',
      enabled: 'Enabled',
      disabled: 'Disabled',
    },
    reports: {
      title: 'Reports Configuration',
      enabled: 'Enabled',
      fields: {
        databaseName: 'Database Name',
        username: 'Username',
        password: 'Password',
        passwordPlaceholder: 'Leave empty to keep current password',
        host: 'Host',
        port: 'Port',
        ssl: 'SSL',
      },
      save: 'Save',
      saving: 'Saving...',
      saveSuccess: 'Reports configuration saved successfully',
      saveError: 'Failed to save reports configuration. Please try again.',
    },
  },
  organizationSelect: {
    placeholder: 'Select organization',
  },
  logs: {
    rawPayloadParseError: 'Raw Payload (Parse Error)',
    unknownEventType: 'Unknown Event Type',
    unknownEvent: 'Unknown Event',
    noDataAvailable: 'No data available',
    events: {
      organizationCreated: 'Organization Created',
      organizationUpdated: 'Organization Updated',
      organizationDeleted: 'Organization Deleted',
      organizationProvisioned: 'Organization Provisioned',
      entitlementGranted: 'Entitlement Granted',
      entitlementRevoked: 'Entitlement Revoked',
      signupCompleted: 'Signup Completed',
    },
  },
};
